/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';

    var app = angular.module('enervee');

    app.directive('calendar', [function() {

        return {
             restrict: 'E',
             template: require('@app/shared/calendar/calendar.html'),
             bindToController: true,  // bind the scope properties above to the controller object
             controller: [
                '$scope',
                function(
                    $scope
                ) {
                 this.$onInit = function () {
                     //initialize calendar selected date to today date
                     $scope.today = function () {
                         $scope.calendarSelDate = new Date();
                     };

                     $scope.today();

                     var CALENDAR_MODE_DAY = "day";

                     //only enable dates in given list
                     var myDisabledDates = function (date) {
                         //if available dates set allow only select them otherwise use original function
                         if ($scope.availableDates.length > 0) {
                             return $scope.availableDates.indexOf(date.date.toDateString()) < 0;
                         }
                         return disabled(date);
                     };

                     $scope.calendar_options = {
                         dateDisabled: myDisabledDates,
                         minMode: CALENDAR_MODE_DAY,
                         maxMode: CALENDAR_MODE_DAY,
                         minDate: new Date(),
                         showWeeks: false
                     };

                     // Disable weekend selection
                     var disabled = function (data) {
                         var date = data.date,
                             mode = data.mode;
                         return mode === CALENDAR_MODE_DAY && (date.getDay() === 0 || date.getDay() === 6);
                     };

                     //initialize selected date
                     $scope.initDate = function (firstDate) {
                         $scope.calendarSelDate = firstDate;
                     };


                     $scope.setDate = function () {
                         var userSelected = true;
                         $scope.setCalDate($scope.calendarSelDate, userSelected);
                     };
                 };
             }]
        };

    }]);

})(angular);